import React, { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';

import { isEmail } from './email-utils';

import TextInputWithError from '../TextInputWithError/TextInputWithError';

export const EmailInput = ({
  className,
  onChange,
  onSubmit,
  onEntryValidation,
  onValueError,
  onBlur,
  value = '',
  placeholder = 'Email',
  block = false,
  disabled = false,
}) => {
  const [emailText, setEmailText] = useState(value);
  const inputRef = useRef(null);

  const handleSubmit = (newValue) => {
    if (newValue && newValue?.trim()?.length && isEmail(newValue)) {
      if (isFunction(onSubmit)) {
        onSubmit(newValue)
      }
      setEmailText('');
    }
  };

  const handleChange = (newValue) => {
    if (isFunction(onChange)) {
      onChange(newValue);
    }
    setEmailText(newValue);
  }

  const handleValueError = useCallback((error) => {
    if (isFunction(onValueError)) {
      onValueError(error)
    }
  }, [onValueError])

  const handleBlur = useCallback((event) => {
    if (isFunction(onBlur)) {
      onBlur(event);
    }
  }, [onBlur])

  const handleEntryValidation = useCallback(newValue => !newValue?.length || (isEmail(newValue) && (!isFunction(onEntryValidation) || onEntryValidation(newValue))), [onEntryValidation])

  return (
    <TextInputWithError
      type="text"
      className={classNames(className)}
      ref={inputRef}
      placeholder={placeholder}
      value={emailText}
      onChange={handleChange}
      onSubmit={handleSubmit}
      onEntryValidation={handleEntryValidation}
      onValueError={handleValueError}
      onBlur={handleBlur}
      errorMessage="Invalid Email"
      block={block}
      disabled={disabled}
    />
  )
};

export default EmailInput;
